export function dash(value: unknown) {
  if (value == null || value === "" || value === "-") return "-"
  return String(value)
}

export function yesNo(value: unknown) {
  if (value === true || value === 1 || value === "1" || value === "yes" || value === "Yes") return "Yes"
  return "No"
}

export function pick(raw: Record<string, unknown> | null | undefined, ...keys: string[]) {
  if (!raw) return undefined
  for (const key of keys) {
    const value = raw[key]
    if (value != null && value !== "") return value
  }
  return undefined
}

export function extractPresetList(payload: unknown): any[] {
  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== "object") return []
  const data = payload as Record<string, any>
  const nested = data.data ?? data.response ?? data
  if (Array.isArray(nested)) return nested
  if (nested && typeof nested === "object") {
    for (const key of ["authorization_presets", "configuration_presets", "presets", "items", "response"]) {
      if (Array.isArray(nested[key])) return nested[key]
    }
  }
  return []
}

export function billingForOlt(items: any[], oltId: string) {
  return (items || []).find((row) => String(row?.olt_id ?? row?.id ?? "") === String(oltId)) || items?.[0] || null
}

export function speedLabel(row: any) {
  const up = row?.upload ?? pick(row?.raw, "upload", "upload_speed", "up")
  const down = row?.download ?? pick(row?.raw, "download", "download_speed", "down")
  if (up && down) return `${down} / ${up}`
  return dash(down || up)
}

export function presetSettings(row: any) {
  const groups = Array.isArray(row?.enforced_settings) ? row.enforced_settings : []
  return groups
    .flatMap((group: any) => (Array.isArray(group?.rows) ? group.rows : []))
    .map((item: any) => `${item.label}: ${item.value}`)
    .join(" · ")
}
